import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("INV主檔")]), _vm._v(" —— 每台 INV 的品牌、型號與容量，作為 INV 同類比較的分組依據。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("分組依據")]), _vm._v("：品牌、型號、實際串接容量三者皆相同才歸為同一組。 實際串接容量以現場接線為準，可能與銘牌容量不同。「同儕群組代號」留空時由系統自動分組。 ")]), _c('li', [_c('strong', [_vm._v("INV 索引須與監控資料的順序一致")]), _vm._v("（第一台為 0），填錯會對應到其他 INV 的資料。 ")]), _c('li', [_vm._v(" 按「由其他主檔產生」可自動帶入 INV 編號、上游節點、串列數、MPPT 數與實際串接容量， 需"), _c('strong', [_vm._v("先完成「MPPT串列對應」與「串列設計」")]), _vm._v("。上述主檔日後異動時，本頁不會自動同步，請重新產生或手動修改。 ")])])]), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "inverter_master",
      "def": _vm.def,
      "site-code": _vm.siteCode
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('b-button', {
          staticClass: "md_btn",
          attrs: {
            "size": "sm",
            "disabled": !_vm.siteCode,
            "title": "從拓撲階層、MPPT串列對應、串列設計彙整 INV 清單與串數、容量，品牌型號填寫一次即可整批寫入"
          },
          on: {
            "click": function click($event) {
              _vm.open = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-project-diagram"
        }), _vm._v(" 由其他主檔產生 ")])];
      },
      proxy: true
    }])
  }, _vm.$listeners)), _c('b-modal', {
    attrs: {
      "title": "由其他主檔產生 INV主檔",
      "size": "xl",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.rows.length
    },
    on: {
      "show": _vm.onShow,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.open,
      callback: function callback($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_vm.loadError ? _c('b-alert', {
    staticClass: "py-2 im_hint",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.loadError))]) : !_vm.loading && !_vm.rows.length ? _c('b-alert', {
    staticClass: "py-2 im_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.siteCode) + " 尚未建立 INV 節點或 MPPT串列對應，無法產生 INV 清單。請先完成「MPPT串列對應」。 ")]) : _c('div', {
    staticClass: "im_hint mb-2"
  }, [_vm._v(" 共 "), _c('strong', [_vm._v(_vm._s(_vm.rows.length))]), _vm._v(" 台。 "), _vm.noDesign ? [_vm._v("尚未建立「串列設計」，"), _c('strong', [_vm._v("實際串接容量將留空")]), _vm._v("。")] : _vm._e(), _vm.existing ? [_vm._v("已經有 " + _vm._s(_vm.existing) + " 列，寫入時"), _c('strong', [_vm._v("已存在的 INV 會略過、不覆蓋")]), _vm._v("。")] : _vm._e()], 2), _vm._l(_vm.specColumns, function (c) {
    return _c('b-form-group', {
      key: c.name,
      staticClass: "mb-2",
      attrs: {
        "label": c.label + (c.required ? ' *' : ''),
        "description": c.name === 'parent_node_id' ? '留空則沿用拓撲階層中各 INV 的上游節點；填寫則整批套用此值' : c.hint,
        "label-cols-md": "3",
        "label-size": "sm"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "type": c.type === 'text' || c.type === 'date' ? c.type : 'number',
        "step": "any",
        "maxlength": c.maxLength
      },
      model: {
        value: _vm.spec[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.spec, c.name, $$v);
        },
        expression: "spec[c.name]"
      }
    })], 1);
  }), _vm.rows.length ? _c('b-table', {
    staticClass: "im_table",
    attrs: {
      "items": _vm.rows,
      "fields": _vm.previewFields,
      "small": "",
      "bordered": ""
    }
  }) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "py-2 mb-0 mt-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };